import { render, staticRenderFns } from "./bookOutsItem.vue?vue&type=template&id=53422efa&"
import script from "./bookOutsItem.vue?vue&type=script&lang=js&"
export * from "./bookOutsItem.vue?vue&type=script&lang=js&"
import style0 from "./bookOutsItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports